import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h2>Page Not Found</h2>
            <h3>404 Error !!!</h3>
        </div>
    );
};

export default NotFound;